<template>
  <el-dialog :title="isEdit ? '编辑轮播图' : '新增小程序轮播图'"
             :visible.sync="visible" width="560px" @close="handleClose">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <!-- 所属小区：只读展示，跟 roomList.vue 432 行思路一致，由父组件/当前账号所在小区自动决定 -->
      <el-form-item label="所属小区" prop="communityId">
        <el-input :value="curCommunityName" readonly placeholder="当前小区">
          <template slot="prepend">将发布到</template>
        </el-input>
      </el-form-item>

      <el-form-item label="主标题" prop="mainTitle">
        <el-input v-model="form.mainTitle" maxlength="50" show-word-limit
                  placeholder="例如：尊贵生活 · 意禾而始" />
      </el-form-item>

      <el-form-item label="副标题" prop="subTitle">
        <el-input v-model="form.subTitle" maxlength="50" show-word-limit
                  placeholder="例如：意式园林美学与现代建筑的邂逅" />
      </el-form-item>

      <el-form-item label="轮播图片" prop="imageUrl">
        <upload-image-url :limit="1" :default-url="form.imageUrl || ''"
                          @notifyUploadCoverImage="onImageChange" />
        <div class="hint">建议 750×420px，JPG/PNG，&lt; 2MB</div>
      </el-form-item>

      <el-form-item label="排序">
        <el-input-number v-model="form.seq" :min="1" :max="999" />
        <span class="hint">数字越小越靠前</span>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveWechatAdvert, updateWechatAdvert } from '@/api/admin/wechatAdvertApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl.vue'

export default {
  name: 'AddWechatAdvert',
  components: { UploadImageUrl },
  data() {
    return {
      visible: false,
      submitting: false,
      isEdit: false,
      // 当前小区名称（只读展示用），从 localStorage 的 hc_currentCommunityInfo 取
      curCommunityName: this.getCommunityName() || '当前小区',
      form: this._defaultForm()
    }
  },
  computed: {
    rules() {
      return {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        imageUrl:    [{ required: true, message: '请上传图片', trigger: 'blur' }]
      }
    }
  },
  methods: {
    _defaultForm() {
      return {
        wechatAdvertId: '',
        communityId: '',
        mainTitle: '',
        subTitle: '',
        imageUrl: '',
        seq: 1
      }
    },
    open(row) {
      // 注意：保留 row 参数兼容父组件旧调用（open(null) / open(row)）
      if (row) {
        // 编辑模式：保留原 communityId（后端约束：小区的轮播图只能由该小区管理员改）
        this.isEdit = true
        this.curCommunityName = row.communityName || this.getCommunityName() || '当前小区'
        this.form = {
          wechatAdvertId: row.wechatAdvertId,
          communityId:    row.communityId,
          mainTitle:      row.mainTitle || '',
          subTitle:       row.subTitle  || '',
          imageUrl:       row.imageUrl  || '',
          seq:            row.seq || 1
        }
      } else {
        // 新增模式：communityId 自动从当前登录管理员所在小区取（跟 roomList.vue 432 行一致）
        this.isEdit = false
        this.curCommunityName = this.getCommunityName() || '当前小区'
        this.form = this._defaultForm()
        this.form.communityId = this.getCommunityId()
      }
      this.visible = true
    },
    onImageChange(urls) {
      // UploadImageUrl 传过来的是数组，取第一个
      this.form.imageUrl = (urls && urls[0]) || ''
    },
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.clearValidate()
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        // 防御性兜底：如果 communityId 仍为空（比如切换过小区但 open 时未刷新），重新取一次
        if (!this.form.communityId || this.form.communityId === '-1') {
          const _cid = this.getCommunityId()
          if (!_cid || _cid === '-1') {
            this.$message.warning('当前账号未绑定小区，请先到顶部选择小区')
            return
          }
          this.form.communityId = _cid
        }
        this.submitting = true
        try {
          const api = this.isEdit ? updateWechatAdvert : saveWechatAdvert
          const res = await api(this.form)
          if (res.code === 0) {
            this.$message.success(this.isEdit ? '编辑成功' : '发布成功')
            this.visible = false
            this.$emit('success')
          } else {
            this.$message.error(res.msg || '提交失败')
          }
        } catch (e) {
          this.$message.error(e.message || '提交失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.hint {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}
</style>
